import { render, staticRenderFns } from "./_button.vue?vue&type=template&id=3300c69f&scoped=true&"
import script from "./_button.vue?vue&type=script&lang=js&"
export * from "./_button.vue?vue&type=script&lang=js&"
import style0 from "./_button.vue?vue&type=style&index=0&id=3300c69f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3300c69f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
